import { DefaultRequest } from 'scripts/api';

class EventNotificationsRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = "EventNotifications";

    super(entityName);
  }

  setEventLogLastEventDate = arrayEvents => {
    var arrayLength;

    if (arrayEvents) {
      arrayLength = arrayEvents.length;

      for (var i = 0; i < arrayLength; i++) {
        var timeValuedTrue = arrayEvents[i].timeValuedTrue;

        if (Monet.Session.Maps.eventLogSort === "DESC" && i === 0) {
          Monet.Session.Maps.eventLogLastEventDate = timeValuedTrue;
          break;
        } else if (
          Monet.Session.Maps.eventLogSort === "ASC" &&
          i === arrayLength - 1
        ) {
          Monet.Session.Maps.eventLogLastEventDate = timeValuedTrue;
        }
      }
    }
  };

  setUrgentEventLogLastEventDate = collectionEvents => {
    collectionEvents.models.forEach((event, index) => {
      const timeValuedTrue = event.get("timeValuedTrue");

      if (Monet.Session.Maps.eventLogSort === "DESC" && i === 0) {
        Monet.Session.Maps.eventUrgentLastEventDate = timeValuedTrue;
        return false;
      } else if (
        Monet.Session.Maps.eventLogSort === "ASC" &&
        index === collectionEvents.size() - 1
      ) {
        Monet.Session.Maps.eventUrgentLastEventDate = timeValuedTrue;
      }
    });
  };

  getEvents = stringSort => {
    const tabName = Monet.Utils.GetTabName();
    const objetoEvento = new App.Collections.EventLogs();
    objetoEvento.allDay(stringSort);
    const objetoEventoClear = new App.Collections.EventLogs();
    objetoEventoClear.clearEventsCheckedTrue(stringSort);

    App.Routers.RouteMonitor.prototype.events = objetoEvento;
    App.Routers.RouteMonitor.prototype.eventsClear = objetoEventoClear;

    if (tabName === "RouteMonitor") {
      App.Routers.RouteMonitor.prototype.events.fetch({
        success: () => {
          App.Routers.RouteMonitor.prototype.eventsClear.fetch({
            success: () => {
              this.renderEventUrgentList();
              App.MakeLayouts.mapScreenConfiguration();
            }
          });
        }
      });
    }
  };

  renderEventUrgentListByTime = () => {
    if (App.Routers.RouteMonitor.prototype.eventsByTime.size()) {
      var arrayEventsUrgentSinceMinuteAgo =
        App.Routers.RouteMonitor.prototype.eventsByTime.at(0).attributes
          .urgentEventLogs;

      if (arrayEventsUrgentSinceMinuteAgo.length !== 0) {
        arrayEventsUrgentSinceMinuteAgo.forEach(function(eventsUrgent) {
          var viewEvents = App.Views.EventNotifications;
          viewEvents.processInformationEventsUrgentList(eventsUrgent, true);
        });
      }
    }
  };

  renderEventUrgentList = () => {
    const eventNotificationIsEnabled = Monet.Security.checkKeyIsEnabled([
      "TRACKER_EVENT_NOTIFICATION"
    ]);

    if (
      App.Routers.RouteMonitor.prototype.events.size() &&
      eventNotificationIsEnabled
    ) {
      const arrayEventsUrgent = App.Routers.RouteMonitor.prototype.events.at(0)
        .attributes.urgentEventLogs;
      const containerHTMl = document.getElementById("conteinerEventUrgent");

      if (containerHTMl) {
        containerHTMl.innerHTML = "";
      }
      const {
        processInformationEventsUrgentList
      } = App.Views.EventNotifications;

      arrayEventsUrgent.forEach(processInformationEventsUrgentList);
    } else {
      const error = new Monet.Exception.ReturnError(
        this,
        "The events collections is empty"
      );
      error.console();
    }
  };

  /**
   * Está sendo chamada em Greenmile.Views.EventNotification.CancelEvent
   */
  closeEvent = (id, context) => {

    var json = {};
    var form = context.parentNode.parentNode;
    var checkBox;
    var textArea;

    if (form) {
      checkBox = form.querySelector('input[type="checkbox"]');
      textArea = form.querySelector("textarea");

      if (checkBox) {
        json[checkBox.name] = checkBox.checked;
      }

      if (textArea) {
        json[textArea.name] = textArea.value;
      }

      json.eventLog = { id: id };
    }

    const request = new DefaultRequest({
      url: "EventLogNotes",
      method: "post",
      dataType: "json",
      data: json,
      success: data => {
        if (data.closeException) {
          App.Objects.EventNotifications.destroyEventElement(id);
        }
        const allTooltipsEver = document.querySelectorAll(
          ".qtip div.qtip-titlebar > a > span"
        );
        //Fecha miseravel
        for (let i = 0, l = allTooltipsEver.length; i < l; i++) {
          allTooltipsEver[i].click();
        }
        var modal = Monet.Session.WindowNotification.cancelEventModal;
        modal.closeModalWindow();
        Monet.Tooltip.hideTooltip(Monet.Session.WindowNotification.selector);
        if (Monet.Utils.GetTabName() === "EventLog") {
          App.Forms.EventLog.pagination.first = 0;
          App.Forms.EventLog.filterBuilder.executeFilter();
        }
      },
      error: e => {
        if (e.status === 409) {
          const errorMessage = JSON.parse(e.responseText).errorMessages;

          const eventWindow = new Greenmile.EventNotifications.Window();
          new Greenmile.Components.AlertModal(eventWindow.getMessageEventLogLocked(errorMessage[0].resource))
            .show();
        }
      }
    });
    request.send();
  };

  destroyEventElement = id => {
    const eventEl = document.getElementById(`eventItemText-id-${id}`);

    if (eventEl) {
      eventEl.previousElementSibling.parentElement.removeChild(
        eventEl.previousElementSibling
      );
      eventEl.parentElement.removeChild(eventEl);
    }

    const $id = $(`#${id}`);
    if ($id.length !== 0) {
      if (typeof $id.qtip().length === "undefined") {
        $id.qtip().destroy();
      }
      $id.remove();
    }

    const $eventUrgent = $(`#event_urgent_${id}`);
    if ($eventUrgent.length !== 0) {
      if (typeof $eventUrgent.qtip().length === "undefined") {
        $eventUrgent.qtip().destroy();
      }
      $eventUrgent.remove();
    }

    const $eventLogQtip = $("#EventLog .qtip");
    if ($eventLogQtip.length !== 0) {
      $eventLogQtip.qtip().destroy();
      $eventLogQtip.remove();
    }

    Monet.Session.WindowNotification.selector = undefined;

    if (App.Objects.RouteMonitorRoutes) {
      App.Objects.RouteMonitorRoutes.updateRouteInfo();
    }
  };

  getEventUrgentsByEventType = (eventTypeId, update) => {
    var eventLog = new App.Collections.EventLogs();
    var dateTimeValuedTrue = Monet.Format.DateTime.formatToISOString(new Date().setHours(0, 0, 0, 0));

    if (update && Monet.Session.Maps.eventUrgentLastEventDate) {
      dateTimeValuedTrue = Monet.Session.Maps.eventUrgentLastEventDate;
    }

    Monet.Session.UrgentEventList.canUpdate = false;

    eventLog.getByEventType(
      eventTypeId,
      dateTimeValuedTrue,
      Monet.Session.Maps.eventLogSort
    );

    eventLog.fetch({
      criteria: '{"filters":["*"}',
      success: function(data) {
        Monet.Session.UrgentEventList.canUpdate = true;
        App.Views.EventNotifications.renderEventUrgent(
          eventTypeId,
          data,
          update
        );
      }
    });
  };
}

App.Routers.EventNotifications = EventNotificationsRouter;
